import React from 'react';

type Props = {
	chartType: string;
	onSelect: (arg0: string) => void;
};

const ChartTypeIcon = ({chartType, onSelect}: Props) => (
	<div className={`di chart-type-icon ${chartType}`} onClick={() => onSelect(chartType)} />
);

export default ChartTypeIcon;
